import { FC, type ReactElement } from "react";
import { PaxCheckDeclarationItem } from "api";
import Content, { ContentNS } from "content/content";

/* components */
import Checkbox from "features/shared/components/checkbox/Checkbox";
import QuestionSampleDeclarations from "../question-sample/QuestionSampleDeclarations";

/* styles */
import QuestionBox from "../../styles/QuestionBox.styled";
import Body from "features/shared/styles/typography/Body.styled";
import YesNoQuestion from "./styles/YesNoQuestion.styled";
import { MicroHeader } from "features/shared/styles/typography/MicroHeader.styled";

interface QuestionProps {
  questions: PaxCheckDeclarationItem[];
  answers: Map<string, string | boolean | undefined>;
  handleChange: (id: string) => (value: boolean) => void;
}

// Keep it almost as a full copy of HaveDocumentQuestionsPane for now
const YesNoQuestionsPane: FC<QuestionProps> = ({
  questions,
  answers,
  handleChange,
}) => {
  const textChecklist = (s: string) =>
    Content.shared.t(s, { ns: ContentNS.checklist });

  const QuestionCaption = (
    declaration: PaxCheckDeclarationItem
  ): ReactElement => {
    return (
      <div>
        <Body>{declaration.questionTitle.name}</Body>
        {declaration.questionTitle.subtitle && (
          <Body className="subtitle">{declaration.questionTitle.subtitle}</Body>
        )}
        {declaration.sampleImage ? (
          <QuestionSampleDeclarations sampleImage={declaration.sampleImage} />
        ) : null}
      </div>
    );
  };

  return (
    <QuestionBox>
      <MicroHeader>{textChecklist("questions.declarations-title")}</MicroHeader>

      {questions.map((question) => {
        // priority to state
        const stateAnswer = answers.get(question.id);
        // if not in state (yet), take from question itself,
        // otherwise declarations are checked by default
        const declarationAnswer =
          question.answer !== undefined && question.answer !== null
            ? question.answer
            : true;
        const checked =
          stateAnswer !== undefined
            ? (stateAnswer as boolean)
            : declarationAnswer;
        return (
          <YesNoQuestion key={question.id}>
            <Checkbox
              label={
                <QuestionCaption
                  id={question.id}
                  questionTitle={question.questionTitle}
                  type={question.type}
                  sampleImage={question.sampleImage}
                  defaultValue={question.defaultValue}
                  isRelevant={question.isRelevant}
                />
              }
              checked={checked}
              onChange={handleChange(question.id)}
              error={null}
            />
          </YesNoQuestion>
        );
      })}
    </QuestionBox>
  );
};

export default YesNoQuestionsPane;
